<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-view-all-users">
  <div class="org-admin-view-all-users--layout">
    <app-org-admin-sidebar class="org-admin-view-all-users--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-view-all-users--content">
      <app-page-header></app-page-header>
      <div class="view-all-users-container">
        
        <!-- Table -->
        <app-table
          [columns]="columns"
          [data]="usersData"
          [scrollHeight]="'400px'"
          [loading]="loading"
          [pagination]="pagination"
          [emptyMessage]="emptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          [dropdownOpenRowIndex]="openDropdownRowIndex"
          [initialSortColumn]="initialSortColumn"
          [initialSortDirection]="initialSortDirection"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)"
        >
          <!-- Custom Status Column -->
          <ng-template #statusCell let-row>
            <div class="status-cell">
              <span 
                class="status-indicator" 
                [class.status-active]="row.accountStatus?.toLowerCase() === 'active'"
                [class.status-inactive]="row.accountStatus?.toLowerCase() === 'inactive'"
              ></span>
              <span>{{ row.accountStatus }}</span>
            </div>
          </ng-template>

          <!-- Custom Action Column (Action button + View details dropdown) -->
          <ng-template #actionCell let-row let-rowIndex="rowIndex">
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                type="button"
                (click)="toggleActionDropdown($event, row, rowIndex)"
                [class.active]="isDropdownOpen(row)"
              >
                <span>Action</span>
              </button>
              <div 
                class="action-dropdown-menu" 
                *ngIf="isDropdownOpen(row)" 
                [attr.data-dropdown-id]="getRowId(row)"
                (click)="$event.stopPropagation()"
              >
                <ul class="dropdown-list">
                  <li class="dropdown-item">
                    <button class="dropdown-link" (click)="handleAction('viewDetails', row)">View details</button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-template>
        </app-table>
        
      </div>
    </div>
  </div>
</div>

<!-- View User Details Modal -->
<app-modal
  [(visible)]="showViewDetailsModal"
  header="User Details"
  [width]="'600px'"
  [showFooter]="false"
  (onCancel)="closeViewDetailsModal()"
>
  <div *ngIf="selectedUserData" class="view-details-modal-content">
    <div class="view-details-content">
      <div class="view-details-row">
        <span class="view-details-label">User Name</span>
        <span class="view-details-value">{{ selectedUserData.userName }}</span>
      </div>
      <div class="view-details-row">
        <span class="view-details-label">Employee ID</span>
        <span class="view-details-value">{{ selectedUserData.employeeId || '—' }}</span>
      </div>
      <div class="view-details-row">
        <span class="view-details-label">Job Title</span>
        <span class="view-details-value">{{ selectedUserData.jobTitle || '—' }}</span>
      </div>
      <div class="view-details-row">
        <span class="view-details-label">Current Role</span>
        <span class="view-details-value">{{ selectedUserData.currentRole || '—' }}</span>
      </div>
      <div class="view-details-row">
        <span class="view-details-label">Account Status</span>
        <span class="view-details-value">{{ selectedUserData.accountStatus || '—' }}</span>
      </div>
      <div class="view-details-row">
        <span class="view-details-label">User Created At</span>
        <span class="view-details-value">{{ selectedUserData.userCreatedAt || '—' }}</span>
      </div>
      <div class="view-details-row view-details-row--last">
        <span class="view-details-label">User Updated At</span>
        <span class="view-details-value">{{ selectedUserData.userUpdatedAt || '—' }}</span>
      </div>
    </div>
    <!-- Asset leaf at bottom -->
    <div class="view-details-modal-leaf-pattern">
      <img src="/assets-leaf.png" alt="" class="view-details-modal-leaf-image" />
    </div>
  </div>
</app-modal>

